var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.333,
    height: 10.667,
    x: 10.667,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.667 5.333H20m-6.667-3a.333.333 0 0 0-.235.569.333.333 0 0 0 .569-.235.335.335 0 0 0-.334-.334h0m0 5.334a.333.333 0 1 0 0 .667.333.333 0 0 0 0-.667h0m4-5H16M17.333 8H16"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.333,
    height: 10.667,
    y: 9.333,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 14.667h9.333m-6.666-3a.334.334 0 1 0 0 .667.334.334 0 0 0 0-.667h0m0 5.333a.334.334 0 0 0-.334.333.334.334 0 1 0 .334-.333h0m4-5H5.333m1.334 5.333H5.333M4 5.333l-2 2v-2a2.666 2.666 0 0 1 2.666-2.666h4M0 5.333l2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.667.667 2 2-2 2"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/default.13a2fcce.svg";
export { ForwardRef as ReactComponent };